// extracted by mini-css-extract-plugin
module.exports = {"dashboard":"Dashboard_dashboard__1wn3V","dashView":"Dashboard_dashView__3AGya"};